import { useEffect, useState } from 'react';
import { useSettings } from '../../context';

export default function MobileScrollTop() {
  const { settings } = useSettings();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!settings.showUpButton) {
      setVisible(false);
      return undefined;
    }

    const scroller = document.querySelector('.page-body');
    if (!scroller) return undefined;

    const onScroll = () => setVisible(scroller.scrollTop > 320);
    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => scroller.removeEventListener('scroll', onScroll);
  }, [settings.showUpButton]);

  if (!settings.showUpButton || !visible) return null;

  const scrollUp = () => {
    document.querySelector('.page-body')?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button type="button" className="mobile-scroll-top" onClick={scrollUp} aria-label="Up">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M10 4l6 6H4l6-6z" fill="currentColor" />
      </svg>
    </button>
  );
}
